import React from 'react';
import { Switch } from 'react-router-dom';
import AuthRoute from './AuthRoute';

import Admin from "../../../pages/adminUser";
import PDF from "../../../pages/transaction/components/Pdf"
import Price from "../../../pages/price";
import Transaction from "../../../pages/transaction";
import Ticket from "../../../pages/ticket";
import Dashboard from "../../../pages/dashboard";
import Company from "../../../pages/company";
import Contact from "../../../pages/contact";
import Singlechat from "../../../pages/chat/Singlechat";
import AdminAttendanceDetails from '../../../pages/superAdmin/attendance/AdminAttendanceDetails';

const SuperAdminRoutes = ({ role }) => {
    return (
        <Switch>

            <AuthRoute path="/app/admin" role={role} roles={["SUPERADMIN"]} component={Admin} />
            <AuthRoute path="/app/price" role={role} roles={["SUPERADMIN"]} component={Price} />
            <AuthRoute path="/app/pdf_view" role={role} roles={["SUPERADMIN"]} component={PDF} />
            <AuthRoute path="/app/company" role={role} roles={["SUPERADMIN"]} component={Company} />
            <AuthRoute path="/app/contact" role={role} roles={["SUPERADMIN"]} component={Contact} />
            <AuthRoute path="/app/attendance-monitor" role={role} roles={["SUPERADMIN"]} component={AdminAttendanceDetails} />


            <AuthRoute path="/app/dashboard" role={role} roles={["SUPERADMIN", "ADMIN", "RECRUITER", "CLIENTCOORDINATOR", "FREELANCER", "SUBVENDOR"]} component={Dashboard} />
            <AuthRoute path="/app/transaction" role={role} roles={["SUPERADMIN", "ADMIN"]} component={Transaction} />
            <AuthRoute path="/app/ticket" role={role} roles={["SUPERADMIN", "ADMIN"]} component={Ticket} />
            <AuthRoute path="/app/singlechat" role={role} roles={["SUPERADMIN", "ADMIN", "RECRUITER", "CLIENTCOORDINATOR",]} component={Singlechat} />
        </Switch>
    );
};

export default SuperAdminRoutes;
